<div>
<app-claim-list></app-claim-list>
</div>